var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "20px",
    height: "30px",
    viewBox: "0 0 34.16 34.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    className: "fil0",
    d: "M4.62 29.4c0,-1.12 0.64,-2.22 1.68,-3.44l-6 -3.79c-0.38,-0.16 -0.37,-0.39 -0.15,-0.67l1.27 -1.08c0.23,-0.14 0.48,-0.2 0.74,-0.13l7.4 1.25 6.17 -6.68 -14.4 -9.74c-0.36,-0.21 -0.39,-0.46 -0.02,-0.74l2.08 -1.66 18.77 5.27 5.54 -5.93c1.86,-1.61 3.67,-2.33 5.05,-1.99 0.76,0.19 1.03,0.42 1.27,1.13 0.46,1.41 -0.25,3.3 -1.94,5.24l-5.93 5.54 5.27 18.77 -1.66 2.08c-0.28,0.37 -0.52,0.34 -0.74,-0.02l-9.74 -14.39 -6.68 6.16 1.25 7.4c0.07,0.26 0.01,0.51 -0.13,0.74l-1.08 1.27c-0.27,0.22 -0.5,0.23 -0.67,-0.15l-3.79 -6c-1.23,1.04 -2.33,1.68 -3.45,1.68 -0.1,-0 -0.12,-0.04 -0.12,-0.14l0 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/Travel.978bb249a90d1b92795e006a09bd438b.svg";
export { ForwardRef as ReactComponent };